<template>
  <div class="lookServer main-container">
    <Button @click="back()" type="primary" ghost class="btn-back">返回</Button>
    <div class="title">
      <div style="display: flex; align-items: center">
        <h1>{{ $route.query.name }}</h1>
        <div class="tag" v-if="$route.query.status == 1">已下架</div>
      </div>
      <div class="instructions-info" v-if="data.instructions && data.isDynamicRate">
        <div>{{ data.instructions }}</div>
      </div>
      <div class="activity-info" v-if="activityInfo">
        <div><i class="huo">活动名称</i> {{ activityInfo.title }}</div>
        <div>
          <i class="huo">活动时间</i> {{ activityInfo.startTime }}至{{ activityInfo.endTime }}
        </div>
      </div>
      <div class="rules-content">
        <div v-for="(item, index) in data.settleRule" :key="index">
          <div class="name">{{ index + 1 }}.{{ item.name }}</div>
          <div class="content-wrap" :class="{ 'hidden-txt': item.hidden}" v-html="item.content"></div>
          <span v-if="item.showIcon">
            <span v-if="item.hidden" @click="item.hidden = false;" class="arrow-wrap">展开
              <Icon type="ios-arrow-down" />
            </span>
            <span v-else @click="item.hidden = true;" class="arrow-wrap">收起
              <Icon type="ios-arrow-up" />
            </span>
          </span>
        </div>
      </div>
    </div>

    <!-- <Tabs v-model="tabId" :animated="false" @on-click="tabChange">
      <TabPane label="当前费率" name="1"></TabPane>
      <TabPane label="历史费率" name="2"></TabPane>
    </Tabs> -->
    <!-- 当前费率 -->
    <rateTable v-show="tabId == '1'" :data="data" type="1" mode="base" :showFold="query.sourceType==2"></rateTable>
    <!-- 历史费率 -->
    <version-list ref="versionList" v-show="tabId == '2'" :query="query"></version-list>
  </div>
</template>

<script>
import { common } from "@/api/mixins";
import tooltip from "@/components/commons/tooltip";
import rateTable from "@/components/commons/feeTemplate/rateTable";
import versionList from '@/components/commons/feeTemplate/versionList';
import _ from "lodash";
export default {
  components: { tooltip, rateTable, versionList },
  mixins: [common],
  data() {
    return {
      isEdit: false,
      tabId: "1",
      query: {},
      data: {
        commissionItems: []
      },
      iconUrl: "",
      activityInfo: null,
    };
  },
  watch: {},
  computed: {},
  activated() {
    this.iconUrl = this.$route.query.iconUrl;
    const userInfo = JSON.parse(localStorage.getItem("userInfo"))
    this.query = {
      productCode:this.$route.query.code,
      productName:this.$route.query.name,
      sourceType:this.$route.query.sourceType,
      id:userInfo.groupId,
      pageType:'productLibrary',
    }
    this.getRate();
  },
  methods: {
    // 切换tab
    tabChange() {
      if(this.tabId == '2') {
        this.$refs.versionList.getData();
      }
    },
    getRate() {
      this.$http({
        url: "/buz/commission/productRateDetailNew",
        type: "GET",
        data: {
          productCode: this.$route.query.code
        }
      }).then(res => {
        if (res.data) {
          if (res.data.settleRule) {
            res.data.settleRule = JSON.parse(res.data.settleRule).map(item => {
              item.showIcon = false;
              item.hidden = false;
              return item
            })
          }
          let num = 3;
          if (res.data.activityInfoVO) {
            this.activityInfo = res.data.activityInfoVO;
          }
          this.data = res.data;
          if (res.data.settleRule) {
            setTimeout(() => {
              let dom = document.querySelectorAll('.content-wrap')
              console.log(dom)
              if (dom) {
                dom.forEach((element, idx) => {
                  this.data.settleRule[idx].showIcon = element.clientHeight > 60;
                  if (element.clientHeight > 60) {
                    this.data.settleRule[idx].hidden = true;
                    element.className = 'content-wrap hidden-txt'
                  }
                });
              }
            }, 100)
          }
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>  .btn-back {
    position: absolute;
    right: 20px;
  }

  .content-wrap {
    font-size: 13px;
    line-height: 20px;
    margin-top: 10px;
    color: #727c8e;
  }

  .hidden-txt {
    max-height: 60px;
    overflow: hidden;
  }

  .rules-content {
    color: #fc5426;
    margin-top: 10px;


    .name {
      margin: 20px 0 10px;
      font-size: 14px;
      line-height: 25px;
      color: #fc5426;
    }


    .show {
      height: unset;
      max-height: unset;
    }

    .arrow-wrap {
      color: #236dff;
      cursor: pointer;
    }
  }

  .fu {
    background: #fff0ea;
    color: #ff7134;
    padding: 4px;
  }

  .info-text {
    color: #ff7134;
    white-space: pre-line;
  }

  .tableBox {
    table {
      width: 100%;
      border-collapse: collapse;

      input {
        // width: 100px;
      }

      thead {
        background: #f8f8f9;
      }

      th {
        border: 1px solid #eee;
        width: 100px;
        padding: 10px 10px;
      }

      td {
        border: 1px solid #eee;
        padding: 10px 10px;
        text-align: center;
      }
    }
  }

  /deep/ .fu {
    background: #fff0ea;
    color: #ff7134;
    border: 1px solid #ff7134;
    border-radius: 4px;
    padding: 4px;
    margin-right: 6px;
  }

  .lookServer {
    /deep/ .valid {
      background: #ff7134;
      width: 52px;
      height: 20px;
      border-radius: 10px;
      text-align: center;
      line-height: 20px;
      display: inline-block;
      color: #fff;
      margin-left: 8px;
      font-size: 12px;
    }

    .title {
      margin-bottom: 15px;
      line-height: 1.5;
      height: unset;

      h1 {
        font-size: 20px;
        color: #3c464f;
        font-weight: bold;
      }

      .tag {
        color: #515c6f;
        font-size: 12px;
        background: #e3e5e8;
        border-radius: 4px;
        width: 50px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        border: 1px solid #ced1d5;
        margin-left: 10px;

        &.active {
          background: #fff0ea;
          color: #ff7134;
          border: 1px solid #ff7134;
        }
      }
    }

    /deep/ td .ivu-table-cell {
      font-size: 16px;
    }

    /deep/ td .ivu-table-cell-slot .detail>div {
      font-size: 16px;
    }

    .borderd {
      /deep/ td .ivu-table-cell {
        font-size: 14px;
      }

      /deep/ .ivu-table tr th {
        border: 1px solid #e9e9e9;
      }

      /deep/ .ivu-table td {
        border: 1px solid #e9e9e9;
        font-size: 14px;
        color: #3c464f;
      }

      /deep/ .ivu-table thead tr {
        th {
          background: #f7f7f7;
          color: #727c8e;
          border-bottom: 0;
        }
      }
    }

    /deep/ .ivu-table-cell {
      padding-left: 0;
      padding-right: 0;
      height: 100%;
      display: flex;
      color: #3c464f;
      font-size: 14px;
      justify-content: center;
      align-items: center;
    }

    /deep/ .ivu-table-cell {
      line-height: 1;
    }

    /deep/ .ivu-table-cell-slot {
      div {
        color: #236dff;
        font-size: 14px;
      }
    }
  }

  .instructions-info {
    margin-top: 10px;
    color: #727C8E;
  }

  .activity-info {
    margin-top: 20px;
    color: #ff7134;
    font-size: 13px;
    line-height: 18px;

    div {
      margin-top: 10px;
    }
  }

  .huo {
    color: #ff5426;
    margin-right: 3px;
  }
</style>
